import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/evcs_stations',
  component: Management,
  redirect: '/evcs_stations/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/evcs_stations/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvcsStations
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/evcs_stations/ListTable'),
          meta: {
            auth: Auth.listEvcsStations,
            tabName: 'all'
          }
        },
        {
          path: 'available',
          component: () => import('@/views/evcs_stations/ListTable'),
          meta: {
            auth: Auth.listEvcsStations,
            tabName: 'available'
          }
        },
        {
          path: 'constructing',
          component: () => import('@/views/evcs_stations/ListTable'),
          meta: {
            auth: Auth.listEvcsStations,
            tabName: 'constructing'
          }
        },
        {
          path: 'maintaining',
          component: () => import('@/views/evcs_stations/ListTable'),
          meta: {
            auth: Auth.listEvcsStations,
            tabName: 'maintaining'
          }
        },
        {
          path: 'unavailable',
          component: () => import('@/views/evcs_stations/ListTable'),
          meta: {
            auth: Auth.listEvcsStations,
            tabName: 'unavailable'
          }
        },
        {
          path: 'unknown',
          component: () => import('@/views/evcs_stations/ListTable'),
          meta: {
            auth: Auth.listEvcsStations,
            tabName: 'unknown'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/evcs_stations/DetailLayout'),
      meta: {
        auth: Auth.showEvcsStation
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/evcs_stations/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsStation
          }
        },
        // 设备
        {
          path: 'equipments',
          component: () => import('@/views/evcs_stations/details/Equipments'),
          meta: {
            tabName: 'equipments', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsStation
          }
        },
        // 设备接口
        {
          path: 'evcs_connectors',
          component: () => import('@/views/evcs_stations/details/EvcsConnectors'),
          meta: {
            tabName: 'evcs_connectors', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsStation
          }
        },
        // 订单
        {
          path: 'orders',
          component: () => import('@/views/evcs_stations/details/Orders'),
          meta: {
            tabName: 'orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvcsStation
          }
        }
      ]
    }
  ]
}
